// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__ZUv1C","image":"Avatar_image__tmOYe","avatar-letters":"Avatar_avatar-letters__6XOb0","small":"Avatar_small__QOQKh"};